import _ from 'lodash';
import { urlNavigate } from '../../helper/utils/navigation.js';
import { safeJsonParse } from '../../helper/utils/safeJsonParse.js';
import { doError, doWarning } from '../responseHandling/responseHandling.actions.js';
import { doCheckEmail, doHandleState, doSendOTP, doSetData } from './waiver.actions.js';
import WaiverProvider from './waiver.apis.js';

const WaiverService = {
    doWaiver: (payload) => async (dispatch) => {
        const { acknowledge, data, message } = await WaiverProvider.doWaiver(payload);
        if (acknowledge && acknowledge === 1) {
            dispatch(doSetData(data));
            dispatch(doHandleState('loadingWaiver', false));
        } else {
            dispatch(doError(message, '', 'Get List'));
        }
    },

    doCheckEmailOrPhone: (payload, navigate) => async (dispatch) => {
        dispatch(doCheckEmail(payload, navigate, null));
    },

    doCheckEmail: (payload, navigate, onSuccess) => async (dispatch) => {
        const response = await WaiverProvider.doCheckEmailOrPhone(payload);
        const { acknowledge, message, children, data } = response;

        if (acknowledge && acknowledge === 1) {
            dispatch(doWarning('Your phone or email is does not registered. Please check your account.', '', ''));
            dispatch(doHandleState('loadingWaiver', false));
            dispatch(doHandleState('isVerifiedWaiver', false));
        } else if (acknowledge && acknowledge === 2) {
            const mappingMinors = (children || []).map((el) => {
                return {
                    ...el,
                    key: el?.childrenID,
                };
            });

            const minors = [
                ...mappingMinors,
                {
                    ...data,
                    childrenID: data['id'] || '', //! FOR WAIVER
                    name: data['fullname'] || '',
                    birthDate: data['birthDate'] || '',
                    statusCode: data['statusCode'] || '0',
                    isWaiver: '1',
                    created_at: data['created_at'] || new Date(),
                    memberNo: data['memberNo'] || '',
                    key: data['id'] || '',
                },
            ];

            const minorsUnique = _.uniqBy(minors, 'childrenID');

            const waiver = { data, children: minorsUnique };

            dispatch(doHandleState('minor', minorsUnique));
            dispatch(doHandleState('loadingWaiver', false));
            dispatch(doHandleState('major', { email: payload?.email ?? '' }));
            dispatch(doHandleState('waiver', data));
            dispatch(doHandleState('isVerifiedWaiver', true));
            dispatch(doHandleState('loadingDetail', false));

            localStorage.setItem('waiver', JSON.stringify(waiver));
            localStorage.setItem('email', data['email'] || '');
            localStorage.setItem('isVerifiedWaiver', true);

            if (typeof onSuccess === 'function') {
                onSuccess(data);
            }
        } else {
            dispatch(doError(message, '', ''));
            dispatch(doHandleState('isVerifiedWaiver', false));
            dispatch(doHandleState('loadingDetail', false));
        }
    },

    doSubmission: (payload, navigate, onSuccess) => async (dispatch) => {
        dispatch(doHandleState('loadingSubmission', true));

        const response = await WaiverProvider.doSubmission(payload);
        const { acknowledge, message, data } = response;

        if (acknowledge && acknowledge === 1) {
            dispatch(doHandleState('dataUserRegist', payload));
            dispatch(doHandleState('parentCode', data['parentCode']));

            setTimeout(() => {
                dispatch(doHandleState('loadingSubmission', false));

                if (typeof navigate === 'function') {
                    navigate(urlNavigate('online-sales', 'home'));
                }

                if (typeof onSuccess === 'function') {
                    onSuccess();
                }
            }, 5000);
        } else {
            dispatch(doHandleState('loadingSubmission', false));
            dispatch(doError(message, '', 'Error'));
        }
    },

    doSetMinor: (payload) => async (dispatch) => {
        dispatch(doHandleState('minor', payload));
    },

    doCalculateOrder: (payload) => async (dispatch) => {
        const filter = payload?.filter((el) => +el?.statusCode !== 1);
        const countMinor = filter?.length;

        dispatch(
            doHandleState('orderSummary', {
                qty: countMinor,
                tax: 0,
                subTotal: countMinor * 100000,
                total: countMinor * 100000,
            }),
        );
    },

    doPaymentProcess: (payload) => async (dispatch) => {
        const { acknowledge, message, data } = await WaiverProvider.doPaymentProcess(payload);
        if (acknowledge && acknowledge === 1) {
            window.location.href = data?.redirect_url ?? '';

            dispatch(doHandleState('loadingWaiver', false));
        } else {
            dispatch(doHandleState('loadingWaiver', false));
            dispatch(doError(message, '', 'Error'));
        }
    },

    doLogin: (payload, navigate, onLogin) => async (dispatch) => {
        dispatch(doHandleState('loadingSignIn', true));

        const response = await WaiverProvider.doLogin(payload);
        const { acknowledge, message, data } = response;

        if (acknowledge && acknowledge === 1) {
            dispatch(doHandleState('loadingSignIn', false));

            localStorage.setItem('token', data?.token ?? '');
            localStorage.setItem('email', payload?.email ?? '');

            if (typeof onLogin === 'function') {
                onLogin(response);
            }
        } else {
            dispatch(doHandleState('loadingSignIn', false));
            dispatch(doWarning(message, '', 'Auth Login'));
        }
    },

    doSignIn: (payload, navigate, onLogin) => async (dispatch) => {
        dispatch(doHandleState('loadingSignIn', true));

        const response = await WaiverProvider.doCheckEmailOrPhone(payload);
        const { acknowledge, message } = response;

        if (acknowledge && acknowledge === 1) {
            localStorage.setItem('email', payload?.email ?? '');
            dispatch(doHandleState('', ''));

            if (typeof onLogin === 'function') {
                onLogin(response);
            }
        } else if (acknowledge && acknowledge === 2) {
            if (typeof onLogin === 'function') {
                onLogin(response);
            }
        } else {
            dispatch(doError(message, '', ''));
        }

        dispatch(doHandleState('loadingSignIn', false));
    },

    doUploadImage: (payload) => async (dispatch) => {
        const { acknowledge, message } = await WaiverProvider.doUploadImage(payload);
        if (acknowledge && acknowledge === 1) {
            dispatch(doHandleState('imgUrl', false));
        } else {
            dispatch(doError(message, '', 'Upload Image'));
        }
    },

    doSendOTP: (payload, navigate, onSended) => async (dispatch) => {
        dispatch(doHandleState('loadingSendOTP', true));

        const { acknowledge, message } = await WaiverProvider.doSendOTP(payload);

        if (acknowledge && acknowledge === 1) {
            localStorage.setItem('emailOTP', payload?.email);

            if (typeof onSended === 'function') {
                onSended();
            }
        } else {
            dispatch(doWarning(message, '', 'Send OTP'));
        }

        dispatch(doHandleState('loadingSendOTP', false));
    },

    doVerifyOTP: (payload, navigate, onVerified) => async (dispatch) => {
        dispatch(doHandleState('loadingVerifyOTP', true));

        const { acknowledge, message } = await WaiverProvider.doVerifyOTP(payload);
        if (acknowledge && acknowledge === 1) {
            localStorage.removeItem('emailOTP');

            dispatch(doHandleState('loadingVerifyOTP', false));
            dispatch(doHandleState('otp', payload?.otp ?? ''));

            if (typeof onVerified === 'function') {
                onVerified();
            }
        } else {
            dispatch(doHandleState('loadingVerifyOTP', false));
            dispatch(doWarning(message, '', 'Verify OTP'));
        }
    },

    doSetPassword: (payload, navigate, onSuccess) => async (dispatch) => {
        dispatch(doHandleState('loadingRegister', true));

        const { acknowledge, message } = await WaiverProvider.doSetPassword(payload);
        if (acknowledge && acknowledge === 1) {
            if (typeof onSuccess === 'function') {
                setTimeout(() => {
                    onSuccess();
                    dispatch(doHandleState('loadingRegister', false));
                }, 1500);
            }
        } else {
            dispatch(doHandleState('loadingRegister', false));
            dispatch(doWarning(message, '', 'Register'));
        }
    },

    doForgotPassword: (payload, navigate, onSuccess) => async (dispatch) => {
        dispatch(doHandleState('loadingSendOTP', true));

        const { acknowledge, message } = await WaiverProvider.doForgotPassword(payload);
        if (acknowledge && acknowledge === 1) {
            dispatch(doSendOTP(payload, navigate, onSuccess));
        } else {
            dispatch(doWarning(message, '', 'Auth Login'));
        }

        dispatch(doHandleState('loadingSendOTP', false));
    },

    doGetOrderById: (payload) => async (dispatch) => {
        const { acknowledge, data, message } = await WaiverProvider.doGetOrderById(payload);

        dispatch(doHandleState('loading', true));

        if (acknowledge && acknowledge === 1) {
            dispatch(doHandleState('orderDetail', data));
            dispatch(doHandleState('loading', false));
        } else {
            dispatch(doWarning(message, '', 'Get Order'));
            dispatch(doHandleState('loading', false));
        }
    },

    doUpdateWaiver: (payload) => async (dispatch) => {
        dispatch(doHandleState('loadingWaiver', true));

        const { acknowledge, message } = await WaiverProvider.doUpdateWaiver(payload);
        if (acknowledge && acknowledge === 1) {
            const waiver = safeJsonParse(localStorage.getItem('waiver'), {});
            const data = waiver['data'] || {};

            if (Object.keys(data).length > 0) {
                dispatch(
                    doCheckEmail(
                        {
                            email: data['email'] || '',
                            phone: data['phone'] || '',
                        },
                        null,
                        null,
                    ),
                );
            }
        } else {
            dispatch(doWarning(message, '', 'Update Waiver'));
        }

        dispatch(doHandleState('loadingWaiver', false));
    },

    doUpdateWaiverPhone: (payload) => async (dispatch) => {
        dispatch(doHandleState('loadingWaiver', true));

        const { acknowledge, message } = await WaiverProvider.doUpdateWaiverPhone(payload);
        if (acknowledge && acknowledge === 1) {
            const waiver = safeJsonParse(localStorage.getItem('waiver'), {});
            const data = waiver['data'] || {};

            if (Object.keys(data).length > 0) {
                dispatch(
                    doCheckEmail(
                        {
                            email: data['email'] || '',
                            phone: data['phone'] || '',
                        },
                        null,
                        null,
                    ),
                );
            }
        } else {
            dispatch(doWarning(message, '', 'Update Waiver'));
        }

        dispatch(doHandleState('loadingWaiver', false));
    },

    doUpdateWaiverEmail: (payload) => async (dispatch) => {
        dispatch(doHandleState('loadingWaiver', true));

        const { acknowledge, message } = await WaiverProvider.doUpdateWaiverEmail(payload);
        if (acknowledge && acknowledge === 1) {
            const waiver = safeJsonParse(localStorage.getItem('waiver'), {});
            const data = waiver['data'] || {};

            if (Object.keys(data).length > 0) {
                dispatch(
                    doCheckEmail(
                        {
                            email: data['email'] || '',
                            phone: data['phone'] || '',
                        },
                        null,
                        null,
                    ),
                );
            }
        } else {
            dispatch(doWarning(message, '', 'Update Waiver'));
        }

        dispatch(doHandleState('loadingWaiver', false));
    },
    doCreateWaiverChild: (payload, navigate) => async (dispatch) => {
        dispatch(doHandleState('loadingWaiver', true));

        const { acknowledge, message } = await WaiverProvider.doCreateWaiverChild(payload);
        if (acknowledge && acknowledge === 1) {
            const waiver = safeJsonParse(localStorage.getItem('waiver'), {});
            const data = waiver['data'] || {};

            if (Object.keys(data).length > 0) {
                dispatch(
                    doCheckEmail(
                        {
                            email: data['email'] || '',
                            phone: data['phone'] || '',
                        },
                        null,
                        null,
                    ),
                );
            }

            console.log(navigate);

            if (typeof navigate === 'function') {
                navigate(urlNavigate('dashboard'));
            }
        } else {
            dispatch(doWarning(message, '', 'Update Waiver'));
        }

        dispatch(doHandleState('loadingWaiver', false));
    },
    doUpdateWaiverChild: (payload) => async (dispatch) => {
        dispatch(doHandleState('loadingWaiver', true));

        const { acknowledge, message } = await WaiverProvider.doUpdateWaiverChild(payload);
        if (acknowledge && acknowledge === 1) {
            const waiver = safeJsonParse(localStorage.getItem('waiver'), {});
            const data = waiver['data'] || {};

            if (Object.keys(data).length > 0) {
                dispatch(
                    doCheckEmail(
                        {
                            email: data['email'] || '',
                            phone: data['phone'] || '',
                        },
                        null,
                        null,
                    ),
                );
            }
        } else {
            dispatch(doWarning(message, '', 'Update Waiver'));
        }

        dispatch(doHandleState('loadingWaiver', false));
    },
    doDeleteWaiverChild: (payload) => async (dispatch) => {
        dispatch(doHandleState('loadingWaiver', true));

        const { acknowledge, message } = await WaiverProvider.doDeleteWaiverChild(payload);
        if (acknowledge && acknowledge === 1) {
            const waiver = safeJsonParse(localStorage.getItem('waiver'), {});
            const data = waiver['data'] || {};

            if (Object.keys(data).length > 0) {
                dispatch(
                    doCheckEmail(
                        {
                            email: data['email'] || '',
                            phone: data['phone'] || '',
                        },
                        null,
                        null,
                    ),
                );
            }
        } else {
            dispatch(doWarning(message, '', 'Update Waiver'));
        }

        dispatch(doHandleState('loadingWaiver', false));
    },
};

export default WaiverService;
